import { finish, error } from '../../../modules/customers/actions/get-asset-flows';

import api from '../../../api';

export function request(dispatch, { id, name, conditions }) {
    let q = {
        'sort': '-date',
        'operationKind': conditions.operationKind,
        'transaction.type': conditions['transaction.type'],
        'transaction.status': conditions['transaction.status'],
        'date[gt]': conditions.startDate,
        'date[lt]': conditions.endDate,
        'perPage': conditions.perPage,
        'page': conditions.page
    };

    api.get(`/customers/${id}/asset-flows`, q, { cache: true }).then(
        ({ results }) => dispatch(finish(id, name, results)),
        ({ errors }) => dispatch(error(id, name, errors))
    );
}
